/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kostenstelleprefix1Inputs */



/**

* @param {_Field_Kostenstelleprefix1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kostenstelleprefix1 = /** @type {((inputs?: _Field_Kostenstelleprefix1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kostenstelleprefix1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Kostenstelle-Präfix")
});
export { _field_kostenstelleprefix1 as "_field_kostenstellePrefix" }